// extracted by mini-css-extract-plugin
export var closed = "styles-module--closed--4aebf";
export var dropdown_wrapper = "styles-module--dropdown_wrapper--eab23";
export var open = "styles-module--open--d5097";
export var resources_menu = "styles-module--resources_menu--2a8ec";